<template>
  <div class="calandar-section">
    <input
      class="date-input"
      :id="id"
      ref="accessDateFrom"
      :min="min"
      :type="isMonthType?'month':'date'"
      @click="handleClick"
      :disabled="disabled"
      v-model="accessInfoArea.AccessDateFromYMD"
      @change="dateSplit"
      tabindex="-1"
    />
    <select
      class="frm-select frm-size-76px"
      :class="{
        error: errorInfo.isIssueDateError | errorInfo.isNengoInputError,
      }"
      :value="wareki.issueDateNengo"
      :disabled="disabled"
      @change="
        (e) => {
          handleValueChange({ issueDateNengo: e.target.value });
        }
      "
      ref="refIssueDateNengo"
    >
      <option v-for="item in ['', '令和', '平成']" :key="item" :value="item">
        {{ item }}
      </option>
    </select>
    <input
      title=" "
      type="url"
      maxlength="2"
      class="frm-text frm-size-xs number-input-right"
      :class="{
        error: errorInfo.isIssueDateError | errorInfo.isYearInputError,
      }"
      :disabled="disabled"
      :value="wareki.issueDateWarekiYear"
      @change="
        (e) => {
          handleValueChange({ issueDateWarekiYear: e.target.value });
        }
      "
    />
    <span class="frm-unit">年</span>
    <input
      title=" "
      type="url"
      maxlength="2"
      class="frm-text frm-size-xs ml-5px number-input-right"
      :class="{
        error: errorInfo.isIssueDateError | errorInfo.isMonthInputError,
      }"
      :disabled="disabled"
      :value="wareki.issueDateWarekiMonth"
      @change="
        (e) => {
          handleValueChange({ issueDateWarekiMonth: e.target.value });
        }
      "
    />
    <span class="frm-unit">月</span>
    <input
      v-if="!isMonthType"
      title=" "
      type="url"
      maxlength="2"
      class="frm-text frm-size-xs ml-5px number-input-right"
      :class="{ error: errorInfo.isIssueDateError | errorInfo.isDayInputError }"
      :disabled="disabled"
      :value="wareki.issueDateWarekiDay"
      @change="
        (e) => {
          handleValueChange({ issueDateWarekiDay: e.target.value });
        }
      "
    />
    <span v-if="!isMonthType" class="frm-unit">日</span>
    <div class="date-picker-wrap">
      <label ref="calendar-icon" class="calendar-icon" :for="id"></label>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import validation from "@/util/validation";
export default {
  data() {
    return {
      id: null,
      accessInfoArea: {
        AccessDateFromYMD: "",
      },
    };
  },
  props: {
    wareki: {
      type: Object,
      default: () => {
        return {
          issueDateNengo: "",
          issueDateWarekiYear: "",
          issueDateWarekiMonth: "",
          issueDateWarekiDay: "",
        };
      },
    },
    errorInfo: {
      type: Object,
      default: () => {
        return {
          isIssueDateError: false,
          isNengoInputError: false,
          isYearInputError: false,
          isMonthInputError: false,
          isDayInputError: false,
        };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    isMonthType: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    wareki: {
      handler(newVal) {
        let date = this.converToSeireki(newVal);
        if (date) {
          this.accessInfoArea.AccessDateFromYMD =
            moment(date).format("YYYY-MM-DD");
        } else {
          this.accessInfoArea.AccessDateFromYMD = "";
        }
      },
      deep: true,
    },
  },
  computed: {
    warekiDate() {
      if (
        this.isMonthType &&
        this.wareki.issueDateNengo &&
        this.wareki.issueDateWarekiYear &&
        this.wareki.issueDateWarekiMonth
      ) {
        return `${this.wareki.issueDateNengo}${this.wareki.issueDateWarekiYear}年${this.wareki.issueDateWarekiMonth}月`;
      } else if (
        !this.isMonthType &&
        this.wareki.issueDateNengo &&
        this.wareki.issueDateWarekiYear &&
        this.wareki.issueDateWarekiMonth &&
        this.wareki.issueDateWarekiDay
      ) {
        return `${this.wareki.issueDateNengo}${this.wareki.issueDateWarekiYear}年${this.wareki.issueDateWarekiMonth}月${this.wareki.issueDateWarekiDay}日`;
      } else {
        return "";
      }
    },
    min(){
      if(this.isMonthType){
        return "1989-01"
      } else {       
        return "1989-01-08"
      }
    }
  },
  mounted() {
    const min = 100000000;
    const max = 999999999;
    let RandomNineDigits = Math.floor(Math.random() * (max - min + 1)) + min;
    this.id = RandomNineDigits;
    this.issueDateNengo = this.wareki.issueDateNengo;
    this.issueDateWarekiYear = this.wareki.issueDateWarekiYear;
    this.issueDateWarekiMonth = this.wareki.issueDateWarekiMonth;
    this.issueDateWarekiDay = this.wareki.issueDateWarekiDay;
  },
  methods: {
    // **********************************************
    // 処理日時で年月日を設定　DC05
    // **********************************************
    dateSplit() {
      let warekiObj = this.converToJapaneseDate(
        this.accessInfoArea.AccessDateFromYMD
      );
      this.$emit("handleDateChange", warekiObj);
      this.$emit("clearDateError");
    },

    converToJapaneseDate(value) {
      if (value) {
        let date = new Date(value);
        let currentDate = new Date();
        const JapaneseEra = [
          { name: "令和", start: new Date("2019-05-01"), end: currentDate },
          {
            name: "平成",
            start: new Date("1989-01-08"),
            end: new Date("2019-04-30"),
          },
          {
            name: "昭和",
            start: new Date("1926-12-25"),
            end: new Date("1989-01-07"),
          },
          {
            name: "大正",
            start: new Date("1912-07-30"),
            end: new Date("1926-12-24"),
          },
          {
            name: "明治",
            start: new Date("1868-01-25"),
            end: new Date("1912-07-29"),
          },
        ];
        let era = JapaneseEra.find((item) => {
          if (date > currentDate) {
            return true;
          } else {
            return date >= item.start && date <= item.end;
          }
        });
        return {
          issueDateNengo: era.name,
          issueDateWarekiYear: date.getFullYear() - era.start.getFullYear() + 1,
          issueDateWarekiMonth: date.getMonth() + 1,
          issueDateWarekiDay: date.getDate(),
        };
      } else {
        return {
          issueDateNengo: "",
          issueDateWarekiYear: "",
          issueDateWarekiMonth: "",
          issueDateWarekiDay: "",
        };
      }
    },
    converToSeireki({
      issueDateNengo,
      issueDateWarekiYear,
      issueDateWarekiMonth,
      issueDateWarekiDay,
    }) {
      if (
        issueDateNengo &&
        issueDateWarekiYear &&
        issueDateWarekiMonth &&
        issueDateWarekiDay
      ) {
        const JapaneseEra = [
          {
            name: "令和",
            startYear: 2019,
            endYear: Infinity,
            startGregorian: new Date(2019, 4, 1),
            endGregorian: Infinity,
          },
          {
            name: "平成",
            startYear: 1989,
            endYear: 2019,
            startGregorian: new Date(1989, 0, 8),
            endGregorian: new Date(2019, 3, 30),
          },
          {
            name: "昭和",
            startYear: 1926,
            endYear: 1989,
            startGregorian: new Date(1926, 11, 25),
            endGregorian: new Date(1989, 0, 7),
          },
          {
            name: "大正",
            startYear: 1912,
            endYear: 1926,
            startGregorian: new Date(1912, 6, 30),
            endGregorian: new Date(1926, 11, 24),
          },
          {
            name: "明治",
            startYear: 1868,
            endYear: 1912,
            startGregorian: new Date(1868, 0, 1),
            endGregorian: new Date(1912, 6, 29),
          },
        ];
        let era = JapaneseEra.find((e) => e.name == issueDateNengo);
        let gregorianYear =
          era.startGregorian.getFullYear() + parseInt(issueDateWarekiYear) - 1;
        let gregorianMonth = parseInt(issueDateWarekiMonth) - 1;
        let gregorianDay = parseInt(issueDateWarekiDay);
        return new Date(gregorianYear, gregorianMonth, gregorianDay);
      } else {
        return "";
      }
    },
    handleClick(e) {
      if (`showPicker` in HTMLInputElement.prototype) {
        e.srcElement.showPicker();
      }
    },
    isNullOrEmpty(val) {
      if (val == null || val == "") {
        return true;
      } else {
        return false;
      }
    },
    japaneseDateValidate(text) {
      if (!text) {
        return true;
      }
      let reg =
        /^(?:令和|平成)(?:[1-9]|[1-9][0-9])年(?:[1-9]|1[0-2])月(?:[1-9]|[12][0-9]|3[01])日$/;
      let valid1 = reg.test(text);
      if (!valid1) {
        this.$emit("handleInvalidDateInput");
        return false;
      }
      let arr = this.dateInputValueSpliter(text);
      if (!(arr && arr.length == 4)) {
        this.$emit("handleInvalidDateInput");
        return false;
      }
      let valid2 = this.checkInputtedIssueDate(...arr);
      if (!valid2) {
        this.$emit("handleInvalidDateInput");
        return false;
      }
      return true;
    },

    dateInputValueSpliter(text) {
      let arr = text
        .split(/([^0-9]+)(\d+)年(\d+)月(\d+)日/)
        .filter((item) => item != "");
      return arr;
    },
    /**
     * 取引年月日チェック
     */
    checkInputtedIssueDate(
      issueDateNengo,
      issueDateWarekiYear,
      issueDateWarekiMonth,
      issueDateWarekiDay
    ) {
      var nengoVal = issueDateNengo.trim();
      var yearVal = issueDateWarekiYear.trim();
      var monthVal = issueDateWarekiMonth.trim();
      var dayVal = issueDateWarekiDay.trim();
      if (
        nengoVal == "令和" &&
        this.isNullOrEmpty(yearVal) &&
        this.isNullOrEmpty(monthVal) &&
        this.isNullOrEmpty(dayVal)
      ) {
        nengoVal = "";
      }

      // 取引年月日の半角数字チェック
      if (!this.isNullOrEmpty(yearVal) && !validation.isNumeric(yearVal)) {
        return false;
      }
      if (!this.isNullOrEmpty(monthVal) && !validation.isNumeric(monthVal)) {
        return false;
      }
      if (!this.isNullOrEmpty(dayVal) && !validation.isNumeric(dayVal)) {
        return false;
      }

      // [取引年月日]の日付妥当性チェック
      //   if (
      //     !this.isNullOrEmpty(nengoVal) ||
      //     !this.isNullOrEmpty(yearVal) ||
      //     !this.isNullOrEmpty(monthVal) ||
      //     !this.isNullOrEmpty(dayVal)
      //   ) {
      // 未入力と入力混在時エラー
      var cnt = 0;
      if (!this.isNullOrEmpty(nengoVal)) {
        cnt++;
      }
      if (!this.isNullOrEmpty(yearVal)) {
        cnt++;
      }
      if (!this.isNullOrEmpty(monthVal)) {
        cnt++;
      }
      if (!this.isNullOrEmpty(dayVal)) {
        cnt++;
      }
      if (cnt > 0 && cnt < 4) {
        return false;
      }

      // 年月日の整合性チェック
      var wreki = "0";
      if (nengoVal === "平成") {
        wreki = "1";
      }
      var msg = validation.checkFilterDate(
        "1",
        wreki,
        yearVal,
        monthVal,
        dayVal,
        "取引年月日"
      );
      if (msg !== "") {
        return false;
      }
      // 和暦有効判定
      var bRet = this.warekiCheck(
        Number(wreki),
        Number(yearVal),
        Number(monthVal),
        Number(dayVal)
      );
      if (!bRet) {
        return false;
      }
      //   }
      return true;
    },
    /**
     * 和暦有効判定
     * @param {*} reki 和暦
     * @param {*} year 年
     * @param {*} month 月
     * @param {*} day 日
     * @returns チェック結果 true  : チェックOK / false : チェックNG
     */
    warekiCheck(reki, year, month, day) {
      if (isNaN(reki) || isNaN(year) || isNaN(month) || isNaN(day))
        return false;

      if (reki == 1) {
        //1:平成　1年1月8日～31年４月30日まで
        //平成元年チェック
        if (year == 1) {
          if (month == 1) {
            if (day < 8) return false;
          }
        }

        //令和元年以降チェック
        if (year == 31) {
          if (month >= 5) {
            if (day >= 1) return false;
          }
        }

        if (year > 31 || year < 1) {
          return false;
        }
      }
      if (reki == 0) {
        //0:令和　元年5月1日から
        //令和元年チェック
        if (year == 1 && month <= 4) {
          return false; // 令和
        }

        if (year < 1) {
          return false;
        }
      }
      return true;
    },
    handleValueChange(obj) {
      this.$emit("handleDateChange", {
        ...this.wareki,
        ...obj,
      });
    },
    initFocus(){
      this.$refs.refIssueDateNengo.focus()
    }
  },
};
</script>
<style scoped>
.calandar-section {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.calandar-section > .frm-select {
  margin-left: 0;
}
.date-picker-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-left: 10px;
}
.calendar-icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-image: url(../assets/images/denchouhou/icon_calendar.png);
  background-size: 100%;
  background-position: center;
}
.date-input {
  width: 0;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: -5px;
}


* + .frm-unit {
  margin-left: 5px;
}
@media (max-width: 768px) {
  .calandar-section {
    margin-left: 0;
  }
}
</style>